import { useState } from 'react';
import { Navigate, createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { DashboardProvider } from './contexts/DashboardContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ConfirmDialog from './components/ConfirmDialog';
import Login from './pages/Login';
import Home from './pages/Home';

function ProtectedLayout() {
  const { token, loading, logout } = useAuth();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  if (loading) {
    return <div className="text-center mt-5"><div className="spinner-border" /></div>;
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <DashboardProvider>
      <div className="d-flex flex-column vh-100">
        <Header onLogout={() => setShowLogoutConfirm(true)} />
        <main className="flex-grow-1 overflow-auto">
          <Outlet />
        </main>
        <Footer />

        {showLogoutConfirm && (
          <ConfirmDialog
            title="Log Out"
            message="Are you sure you want to log out?"
            confirmLabel="Log Out"
            onConfirm={() => { setShowLogoutConfirm(false); logout(); }}
            onCancel={() => setShowLogoutConfirm(false)}
          />
        )}
      </div>
    </DashboardProvider>
  );
}

const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    element: <ProtectedLayout />,
    children: [
      { path: '/', element: <Home /> },
    ],
  },
]);

export default function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
